export const environment = {
  RECAPTCHA_SITE_KEY_V3: "6Le9jEIqAAAAAHOWVwMfbRooECb22W22Ajg7Z7FF",
  GOOGLE_API_KEY_MAPS: "AIzaSyAfPU3KhRioZmGhbQVia2_g_VFaROTIRjU",
  ACCOUNT_NAME_BLOB_STORAGE: "storageyes7tickets",
  SAS_TOKEN_BLOB_STORAGE_AZURE:
    "sv=2024-11-04&ss=bfqt&srt=co&sp=rwdlacupiytfx&se=2030-02-15T06:51:44Z&st=2026-02-14T22:36:44Z&spr=https&sig=m9Ni0Md27KNyisao91en%2FoTSfCAzIT0urHm%2BmN3ZaZQ%3D",
  BLOB_URL: "https://storageyes7tickets.blob.core.windows.net/banner-events",
  production: false,
  API_BACKEND: "https://dev-api.yes7tickets.com",

  GOOGLE_CLIENT_ID:
    "114266364653-crjr31auoir6i5qncqdv3iao3ap53e2a.apps.googleusercontent.com",

  APPLE_CLIENT_ID: "com.yes7tickets.web",
  APPLE_REDIRECT_URI: "https://dev.yes7tickets.com/auth/apple/callback",
};